import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

export const CHANNEL_NUMBERING_STORAGE_KEY = 'spikescope_channel_numbering';
export const normalizeChannelNumbering = value => value === 0 || value === '0' ? 0 : 1;
export const displayChannel = (channel, base = 1) => {
  if (channel === null || channel === undefined || channel === '') return channel;
  const number = Number(channel);
  return Number.isFinite(number) ? number - (base === 0 ? 1 : 0) : channel;
};
export const recordingChannel = (channel, base = 1) => {
  if (channel === null || channel === undefined || channel === '') return null;
  const number = Number(channel);
  return Number.isInteger(number) && number >= base ? number + (base === 0 ? 1 : 0) : null;
};
const ChannelNumberingContext = createContext(1);

export function ChannelNumberingProvider({ children }) {
  const { profile } = useAuth();
  const [base, setBase] = useState(() => {
    try { return normalizeChannelNumbering(localStorage.getItem(CHANNEL_NUMBERING_STORAGE_KEY)); }
    catch { return 1; }
  });
  useEffect(() => {
    const saved = profile?.preferences?.channelNumbering;
    if (saved !== undefined) {
      const next = normalizeChannelNumbering(saved);
      setBase(next);
      try { localStorage.setItem(CHANNEL_NUMBERING_STORAGE_KEY, String(next)); }
      catch { /* The profile still supplies the preference when storage is unavailable. */ }
    }
  }, [profile?.preferences?.channelNumbering]);
  return <ChannelNumberingContext.Provider value={base}>{children}</ChannelNumberingContext.Provider>;
}

// Internal IDs and API requests stay one-based; only visible labels change.
export const useChannelLabel = () => {
  const base = useContext(ChannelNumberingContext);
  return useCallback(channel => displayChannel(channel, base), [base]);
};
export const useRecordingChannel = () => {
  const base = useContext(ChannelNumberingContext);
  return useCallback(channel => recordingChannel(channel, base), [base]);
};
